import { render, staticRenderFns } from "./NewGroupStepOne.vue?vue&type=template&id=7872d69a&scoped=true"
import script from "./NewGroupStepOne.vue?vue&type=script&lang=js"
export * from "./NewGroupStepOne.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "7872d69a",
  null
  
)

export default component.exports